export const EMBED_CONFIGURATION_PATH_V1 = '/api/v1/embed-configuration';

export const LOCKSPEC_PATH = `${EMBED_CONFIGURATION_PATH_V1}/lockspec`;
export const LOCKSPEC_DETAIL_PATH = `${LOCKSPEC_PATH}/:lockSpecId`;

export const WIDGET_CONFIGURATION_PATH = `${EMBED_CONFIGURATION_PATH_V1}/:wid`;
